import { useEffect, useMemo, useState } from "react";
import { ProjectCard } from "../components/ProjectCard";
import { projects } from "../data/projects";

const categories = ["All", ...Array.from(new Set(projects.flatMap((project) => project.categories)))] as const;

export function ProjectArchivePage() {
  const [filter, setFilter] = useState<string>("All");
  const filtered = useMemo(() => filter === "All" ? projects : projects.filter((project) => project.categories.includes(filter)), [filter]);

  useEffect(() => {
    document.title = "Projects — Yuddhish Chooah";
    return () => { document.title = "Yuddhish Chooah — AI Engineer & Robotics Researcher"; };
  }, []);

  return (
    <main id="main-content" className="archive-page shell">
      <header className="page-hero">
        <p className="section-kicker"><span className="panel-number">A</span><span>Project archive</span></p>
        <h1>Systems with a reason to exist.</h1>
        <p>Research, prototypes and engineering capability across robotics, applied AI, software and data.</p>
      </header>
      <div className="project-filters" aria-label="Filter projects">
        {categories.map((category) => (
          <button key={category} type="button" className={filter === category ? "active" : ""} onClick={() => setFilter(category)} aria-pressed={filter === category}>{category}</button>
        ))}
      </div>
      <div className="project-grid archive-grid" aria-live="polite">
        {filtered.map((project) => <ProjectCard key={project.slug} project={project} index={projects.indexOf(project)} />)}
      </div>
    </main>
  );
}
